<app-message-header></app-message-header>
<div style="padding-top: 10px; margin-right: 74px;margin-left: 20px;">
    <div class="mat-elevation-z8" style="display:inline;" >
    <mat-form-field appearance="outline" [floatLabel]="'never'">     
        <input matInput (keyup)="applyFilter($event.target.value)" matInput placeholder="Search" [(ngModel)]="search" >
        <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
  </div>
   <!--Date Range Drop Down-->
    <div class="col-md-2 col-xs-2 ms-auto dateDropDownStyle " style="display:inline;float: right;">
        <select name="dateRange" class="dateRange shadow" id="dateRange" [(ngModel)]="selectedDateRange" (change)="switchDateRange();">
            <option value="last30">Last 30 days</option>
            <option value="choosedate">Date range</option>
        </select>
        <div *ngIf="chooseDate" class="dateSelectionDiv">
            <input class="dateSelection"  #drp="bsDaterangepicker" bsDaterangepicker [readonly]="true" [maxDate]="bsValue" [(ngModel)]="bsRangeValue" [bsConfig]="{containerClass: 'theme-default',rangeInputFormat: 'DD-MM-YYYY' }" (bsValueChange)="selectDates($event)" >
        </div>
    </div>
</div>
<div  class="col-md-12 col-sm-12 col-xs-12" style="background-color: #eeeeee;">
    <div class="table-container">
        <div style="padding-top: 3px;overflow-x: scroll;">
           <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="companyName">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> Reseller</th>
                <td mat-cell *matCellDef="let element">
                    <div class="textOverflow"> {{element.company}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="applicationName">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> Application Name</th>
                <td mat-cell *matCellDef="let element">
                    <div class="textOverflow"> {{element.applicationName}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="wabaId">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> Waba Id</th>
                <td mat-cell *matCellDef="let element">
                    <div class="textOverflow"> {{element.wabaId}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="country">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> Country</th>
                <td mat-cell *matCellDef="let element">
                    <div class="textOverflow"> {{element.country}}
                    </div>
                </td>
            </ng-container>
    
            <ng-container matColumnDef="conversationDirection">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> Conversation Direction</th>
                <td mat-cell *matCellDef="let element">
                    <div class="textOverflow"> {{element.conversationDirection}}
                    </div>
                </td>
            </ng-container>
            
            <ng-container matColumnDef="conversationType">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> Conversation Type</th>
                <td mat-cell *matCellDef="let element">
                    <div class="textOverflow"> {{element.conversationType}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="conversationCount">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> Conversation Count</th>
                <td mat-cell *matCellDef="let element">
                    <div class="textOverflow"> {{element.conversationCount}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="cost">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;">Total Cost (USD)</th>
                <td mat-cell *matCellDef="let element">
                    <div class="textOverflow"> {{element.messageCost}}
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>     
            <tr mat-row style="cursor: context-menu;" *matRowDef="let row; columns: displayedColumns;"></tr>   
          </table>
        </div>
        <img  *ngIf="pageLoader" src="assets/images/uib-loading-500x500.gif"  alt="Page Loader" class="imageLoader" />
        <div *ngIf="recordNotFound && !pageLoader && applicationDetails.length==0 && dataSource.length == 0">
            <div id="notFoundDiv" *ngIf="applicationDetails.length==0 && dataSource.length == 0" style="color:  black; font-weight: bold; text-align: center;">  No Records Found</div> 
        </div>     

      <div *ngIf="(paginationCount>5); then thenBlock else elseBlock" ></div>
      <ng-template #thenBlock>  <app-pagination [collectionSize]="paginationCount" [pageSize]="10" [(page)]="page" [maxSize]="3" [disabled]="paginationDisabled" (pageChange)="pageChanged2($event)"></app-pagination></ng-template>
      <ng-template #elseBlock>
          <div *ngIf="(paginationCount<5); then tblock "></div>
      </ng-template>
      <ng-template #tblock></ng-template>
        
    </div>
</div> 


